import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useMemo,
} from "react";

import { UniqueTabData, UniqueTabOptions } from "@/data/types";

interface UniqueTabContextType {
  options: UniqueTabOptions;
  data: UniqueTabData[];
}

const UniqueTabContext = createContext<UniqueTabContextType | null>(null);

type Props = PropsWithChildren<{
  options: UniqueTabOptions;
  data: UniqueTabData[];
}>;

export const UniqueTabProvider: FC<Props> = ({ children, options, data }) => {
  const value = useMemo(() => ({ options, data }), [options, data]);

  return (
    <UniqueTabContext.Provider value={value}>
      {children}
    </UniqueTabContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useUniqueTabContext = () => {
  const context = useContext(UniqueTabContext);

  if (!context) {
    throw new Error(
      "useUniqueTabContext must be used within a UniqueTabProvider",
    );
  }

  return context;
};
